import { render, staticRenderFns } from "./PlacementsInfoStep.vue?vue&type=template&id=4c51348e"
import script from "./PlacementsInfoStep.vue?vue&type=script&lang=js"
export * from "./PlacementsInfoStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports